'use strict';
angular.module('bringgApp.filters').filter('toFixed', function () {
	return function (input, decimals) {
		if (!input) {
			return '';
		}
		return parseFloat(input).toFixed(decimals);
	};
});
